isRetyableTimeout